import api from './axiosApi'

export interface CommentAuthor {
  id: string
  display_name?: string | null
}

export interface CommentRead {
  id: string
  content: string
  author?: CommentAuthor | null
  created_at: string
  updated_at?: string | null
  is_deleted?: boolean
}

export interface CommentCreate {
  content: string
}

interface PaginationMeta {
  skip: number
  limit: number
  total: number
  has_more: boolean
}

export interface PaginatedCommentsResponse {
  data: CommentRead[]
  pagination: PaginationMeta
}

/**
 * Fetch comments for a plan (paginated)
 */
export async function fetchComments(
  planId: string,
  offset = 0,
  limit = 50
): Promise<PaginatedCommentsResponse> {
  const response = await api.get<PaginatedCommentsResponse>(
    `/plans/${planId}/comments`,
    { params: { offset, limit } }
  )
  return response.data
}

/**
 * Create a comment on a plan
 */
export async function createComment(
  planId: string,
  body: CommentCreate
): Promise<CommentRead> {
  const response = await api.post<CommentRead>(
    `/plans/${planId}/comments`,
    body
  )
  return response.data
}
